var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat;

var UsingForDeclaration = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;

    if (node.typeName) {
      return concat(['using ', node.libraryName, ' for ', path.call(_print, 'typeName'), ';']);
    }

    return concat(['using ', node.libraryName, ' for *;']);
  }
};
module.exports = UsingForDeclaration;